<template>
    <div>
        <div v-for="field in basic" :key="field.key" class="address-component">
            <span v-if="address[field.key]">{{address[field.key]}}</span>
            <i v-else>
                ({{field.label}} not set)
            </i>
        </div>
        <div class="m-t-sm">
            <div>{{address.addressLine1}}</div>
            <div>{{address.addressLine2}}</div>
            <div>{{address.city}}, {{address.state}} - {{address.postal}}</div>
            <div>{{address.country}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name : "AddressDisplay",
    props : {
        address : {
            type : Object,
            required : true,
        },
    },
    computed : {
        basic () {
            return [
                { key : 'name', label : 'Name' },
                { key : 'email', label : 'Email' },
                { key : 'phone', label : 'Phone' },
            ];
        }
    }
}
</script>

<style scoped>
    .address-component {
        margin-bottom:2px;
    }
</style>
